import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import { Text } from '@calm-web/design-system';

const AVATAR_SIZE = 44;

const clampLines = (lines: number) => css`
	-webkit-box-orient: vertical;
	-webkit-line-clamp: ${lines};
	display: -webkit-box;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Container = styled.div<{ $variant: 'daily' | 'plain' }>`
	display: flex;
	gap: 12px;
	margin-top: ${p => (p.$variant === 'daily' ? 12 : 6)}px;
	min-height: ${p => (p.$variant === 'daily' ? AVATAR_SIZE : 0)}px;
	text-align: left;
`;

export const Avatar = styled.div`
	border-radius: 50%;
	flex-shrink: 0;
	height: ${AVATAR_SIZE}px;
	overflow: hidden;
	position: relative;
	width: ${AVATAR_SIZE}px;
`;

export const TextColumn = styled.div<{ $variant: 'daily' | 'plain' }>`
	display: flex;
	flex-direction: column;
	gap: ${p => (p.$variant === 'plain' ? 4 : 0)}px;
	min-width: 0;
`;

export const Title = styled(Text).attrs({ styleAs: 'h5' })`
	${clampLines(2)}
	color: ${palette('white')};
	font-size: 13px;
	font-weight: 600;
	line-height: 1.3;
	margin: 0;
`;

export const Descriptor = styled(Text).attrs({ el: 'p', styleAs: 'h6' })<{ $lines: number; $topGap: number }>`
	${p => clampLines(p.$lines)}
	color: ${palette('white')};
	font-size: 12px;
	font-weight: 400;
	line-height: 1.3;
	margin: ${p => p.$topGap}px 0 0;
	opacity: 0.8;
`;

export const Line = styled(Text).attrs({ el: 'p', styleAs: 'h6' })<{ $topGap: number }>`
	${clampLines(1)}
	color: ${palette('white')};
	font-size: 12px;
	font-weight: 400;
	line-height: 1.3;
	margin: ${p => p.$topGap}px 0 0;
`;
